import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import http from "../helpers/http";
import config from "../config/config";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const CouponDisplay = () => {
  const query = useQuery();
  const token = query.get("token");
  const [couponCode, setCouponCode] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCode = async (token) => {
    setLoading(true);
    try {
      const data = await http.post(`${config.api_url}/general/code-check`, {
        token: decodeURIComponent(token),
      });
      if (data?.data?.code) {
        setCouponCode(data.data.code);
      }
    } catch (error) {
      console.error("Error fetching coupon code", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCode(token);
    }
  }, []);

  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "200px 0",
        }}
      >
        <h1 style={{ fontSize: "2rem", marginBottom: "20px" }}>
          🎉 Your Coupon Code
        </h1>

        {loading ? (
          <div className="skeleton-box"></div>
        ) : couponCode ? (
          <div
            style={{
              fontSize: "2.5rem",
              color: "green",
              fontFamily: "monospace",
              backgroundColor: "#fff",
              padding: "20px 40px",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
          >
            {couponCode}
          </div>
        ) : (
          <p style={{ fontSize: "1.2rem", color: "#555" }}>
            No coupon code found
          </p>
        )}
      </div>

      {/* Skeleton CSS */}
      <style>
        {`
          .skeleton-box {
            width: 240px;
            height: 60px;
            border-radius: 10px;
            background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);
            background-size: 200% 100%;
            animation: shimmer 1.2s infinite;
          }

          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>
    </>
  );
};

export default CouponDisplay;
